export const defaultRegistryUrl = 'https://nodejs.org/dist';

export const datasource = 'node-version';
